"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var retry_service_1 = require("./retry-service");

var RetryStrategy =
/** @class */
function () {
  function RetryStrategy() {
    this.strategy = function (options) {
      return function (attempts) {
        return attempts.pipe(operators_1.mergeMap(function (error, i) {
          var retryAttempt = i + 1; // if maximum number of retries have been met
          // or response is a status code we don't wish to retry, throw error

          if (retryAttempt > options.maxRetryAttempts) {
            // request cannot be retried anymore
            return rxjs_1.throwError(error);
          }

          var statusCode = 0;

          if (error && error.originalError && error.originalError.response && error.originalError.response.status) {
            statusCode = error.originalError.response.status;
          } // check if request can be retried by looking into allowed retry status codes


          if (!options.useRetryForResponseCodes.find(function (m) {
            return m === statusCode;
          })) {
            // request cannot be retried
            return rxjs_1.throwError(error);
          } // calculate retry time


          var retryTimeout = retry_service_1.retryService.getRetryTimeout(retryAttempt); // debug log attempt

          retry_service_1.retryService.debugLogAttempt(retryAttempt, retryTimeout);
          return rxjs_1.timer(retryTimeout);
        }));
      };
    };
  }

  return RetryStrategy;
}();

exports.RetryStrategy = RetryStrategy;
exports.retryStrategy = new RetryStrategy();